import React, { Component } from 'react'; 
import axios from 'axios';

const PlotExchange = async exchangeForm => {
  return await new Promise((resolve,reject) => {
    const fd = new FormData();
    fd.append('name',exchangeForm.name);
    fd.append('mobileNumber',exchangeForm.mobileNumber)
    fd.append('email',exchangeForm.email)
    fd.append('plot',exchangeForm.plot)
    fd.append('plotNo',exchangeForm.plotNo)
    fd.append('FormActionsComes',exchangeForm.formComesFrom)
    fd.append('units',exchangeForm.units)
    fd.append('pricePerUnit',exchangeForm.pricePerUnit)
    fd.append('totalPrice',exchangeForm.totalPrice)
    if(exchangeForm.selectedFile){
    fd.append('image', exchangeForm.selectedFile, exchangeForm.selectedFile.name);
  }
    axios.post('https://internationalstrategicconsultants.com/iscPropExApi/anyQuestions.php', fd
    ).then(res => {
        resolve(res);
        
      
      })
      .catch(error => {
            reject(error);
        }
        );
  })
  
}


export  default PlotExchange;

